<script lang="ts" setup>
  import { ref } from 'vue'
  import { useAuthStore } from '@/stores'
  import ButtonDefault from '@/elements/ButtonDefault.vue'

  const isImpersonated = ref(false)
  const authStore = useAuthStore()
  authStore.$subscribe((_mutation, state) => {
    isImpersonated.value = state.impersonated_user !== undefined
  })
  const stopImpersonation = async () => {
    await authStore.stopUserImpersonation()
  }
</script>

<template>
  <div>
    <div
      v-if="isImpersonated"
      class="bg-orange-600 text-center py-1 sm:py-2 px-2 sm:px-4 items-center text-indigo-100 leading-none w-full">
      Achtung! Sie sind in einer Benutzerübernahme!
      <ButtonDefault
        label="Übernahme beenden"
        severity="info"
        size="small"
        @click="stopImpersonation" />
    </div>
  </div>
</template>
